import React from 'react';
import { Link } from 'react-router-dom';

function ModificationInfo({ modification, setShowGreeniaAI }) {
  return (
    <div className="w-75 ms-auto mb-3">
      <div className="bg-muted border border-dark p-3 rounded-3 shadow">
        <h5 className="fs-6">Nuova Modifica Data Creata</h5>
        <hr />
        <div>
          <div className="row">
            <div className="col-12">
              <p>
                <small>
                  Per vedere le informazioni della modifica dati premi il pulstante sotto.
                </small>
              </p>
            </div>
            <div className="col-12">
              <Link
                onClick={() => setShowGreeniaAI(false)}
                className="btn btn-dark"
                to={`/after-sale/purchase/modification/${modification.modifyDataId}`}
              >
                Visualizza Modifica Dati
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModificationInfo;
